import "../../../../App.css"
import { useEffect, useState } from 'react';
import NavbarVerical from '../../../Navbar/navbarVertical';
import { Card, Form, Row, Col, Button, DropdownButton, Table, FormControl } from 'react-bootstrap';
import { getCourse, getApplicationsByCourse, unlockRegistration, getAllStudentApplications, getStudentDetailsById } from "../../../api/unlockregistration";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    Document, Page, Text, View, PDFDownloadLink, Font, Image,
    Table as PDFTable,
} from '@react-pdf/renderer';
import styles from "../../../../styles/pdfstyle"

function UnlockRegistrationStudent() {
    const [selectedCourse, setSelectedCourse] = useState([]);
    const [courses, setCourses] = useState([]);
    const [applicationNo, setApplicationNo] = useState("");
    const [studentDetails, setStudentDetails] = useState(null);

    const [allApplication, setAllApplication] = useState([]);
    const [error, setError] = useState('');
    const [remark, setRemark] = useState("");
    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;
    const printDate = new Date();
    const formattedDate = printDate.toLocaleDateString();
    const formattedTime = printDate.toLocaleTimeString();
    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const [courseResponse, applicationRes] = await Promise.all([
                    getCourse(token),
                    getAllStudentApplications(token),
                ]);
                setCourses(courseResponse.data);
                setAllApplication(applicationRes.data)
                console.log("all Application response:", applicationRes.data)
            } catch (error) {
                setError("Error fetching data:", error);
            }
        };
        fetchInitialData();
    }, [token]);

    const handleCourseChange = async (event) => {
        const selectedId = event.target.value;
        setSelectedCourse(selectedId);
        setApplicationNo("");
        setStudentDetails(null);
    };
   
    const handleApplicationNoChange = async (event) => {
        const enteredApplicationNo = event.target.value;
        setApplicationNo(enteredApplicationNo);

        if (selectedCourse && enteredApplicationNo) {
            try {
                const response = await getApplicationsByCourse(token, selectedCourse);
                const applications = response.data;
                console.log("Applications:", applications);

                const matchedApplication = applications.find(
                    (app) => app.applicationNumber.toLowerCase() === enteredApplicationNo.toLowerCase()
                );

                if (matchedApplication) {
                    setStudentDetails(matchedApplication);
                    setError("");
                    const studentId = matchedApplication.userInfo.id;
                    const studentIdArray = [studentId];
                    console.log("Student ids:", studentIdArray)
                    const studentDetailsResponse = await getStudentDetailsById(studentIdArray, token);
                    console.log("studentDetailsResponse:", studentDetailsResponse);
                    if (studentDetailsResponse.data.length > 0) {
                        setStudentDetails(prevState => ({
                            ...prevState,
                            studentDetails: studentDetailsResponse.data[0]
                        }));
                    } else {
                        setError("No student details found.");
                    }
                } else {
                    setStudentDetails(null);
                    setError("No matching application found");
                }
            } catch (err) {
                console.error("Error fetching application details", err);
                setError("Error fetching application details");
            }
        } else {
            toast.error("Please Select Course ");
            setStudentDetails(null);
            setError("");
        }
    };

    const handleSubmit = async () => {
        if (!selectedCourse || !applicationNo) {
            toast.error(!selectedCourse ? "Please select a course" : "Please enter an application number");
            return;
        }
        if (!window.confirm("Are you sure you want to unlock this application?")) {
            return;
        }
        try {
            const requestbody = {
                applicationNumber: applicationNo,
                remark: remark,
            };
            const response = await unlockRegistration(requestbody, token);

            if (response.status === 200) {
                toast.success("Registration unlocked successfully!");
            } else {
                throw new Error("Failed to unlock registration");
            }
        } catch (error) {
            const message = error.response?.data?.message === "Application is already unlocked"
                ? "This application has already been unlocked"
                : "An error occurred while unlocking registration";
            toast.error(message);
            setError(message);
        }
    };

    const unlockedApplications = allApplication.filter((app) => !app.lock);
    const PDFReport = ({ unlockedApplications }) => (
        <Document>
            <Page style={styles.page} size="A4" orientation="landscape">
                <View
                    style={{
                        flex: 1,
                        borderWidth: 1,
                        borderColor: "#000",
                        borderRadius: 5,
                        padding: 6, 
                    }}
                >
                    <View style={styles.section}>
                        <View style={{ width: "100%", textAlign: "center" }}>
                            <Text
                                style={{
                                    textAlign: "center",
                                    fontSize: 10,
                                    
                                    marginBottom: "5px",
                                }}
                            >
                                Unlocked Students Report
                            </Text>
                            <View>
                                <View style={styles.hr_divider} />
                            </View>
                        </View>

                    
                        <View style={styles.table}>
                            <View style={styles.table}>
                                <View style={styles.tableHeaderRow}>
                                    <Text style={styles.srNoHeaderCell}>Sr.No.</Text>
                                    <Text style={styles.tableHeaderCell}>Reg. No.</Text>
                                    <Text style={styles.tableHeaderCell}>Reg Date</Text>
                                    <Text style={styles.tableHeaderCell}>Name</Text>
                                    <Text style={styles.tableHeaderCell}>Course</Text>
                                    <Text style={styles.tableHeaderCell}>Lock Status</Text>
                                    <Text style={styles.tableHeaderCell}>Fees Paid </Text>
                                    <Text style={styles.tableHeaderCell}>Remark </Text>
                                </View>
                            </View>

                            {unlockedApplications.map((app, index) => (
                                <View key={app.id} style={styles.tableRow}>
                                    <Text style={styles.srNoCell}>{index + 1}</Text>
                                    <Text style={styles.tableCell}>
                                        {app.applicationNumber}
                                    </Text>
                                    <Text style={styles.tableCell}>
                                        {app.applicationDate}
                                    </Text>
                                    <Text style={styles.tableCell}>
                                        {app.userInfo.email}
                                    </Text>
                                    <Text style={styles.tableCell}>
                                        {app.course.courseName}
                                    </Text>
                                    <Text style={styles.tableCell}>
                                        {app.lock ? "Locked" : "Unlocked"}
                                    </Text>

                                    <Text style={styles.tableCell}>
                                    </Text>
                                    <Text style={styles.tableCell}>
                                        {app.remark}
                                    </Text>

                                </View>
                            ))}
                        </View>

                        <View style={styles.footer}>
                            <Text>
                                Print Date: {formattedDate} | {formattedTime}
                            </Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    );

    const handleCancel = () => {
        setSelectedCourse("");
        setApplicationNo("");
        setStudentDetails(null)
    }
    return (
        <>
            <NavbarVerical />
            <div className="content-area">
                <Card>
                    <Card.Body>
                        <p style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}>Unlock Registration Student</p>
                        <Form>
                            <Row className='mt-4'>
                                <Col>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                        >
                                            Course<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Select type="text"
                                                placeholder="Enter Course"
                                                id="  Course"
                                                required
                                                value={selectedCourse}
                                                onChange={handleCourseChange}
                                            >
                                                <option value="">Select Course</option>
                                                {courses.map((course) => (
                                                    <option key={course.id} value={course.id}>
                                                        {course.courseName}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown"
                                        >
                                            Application No For Search<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="text"
                                                placeholder="Enter Registration No"
                                                id=" RegistrationFee"
                                                value={applicationNo}
                                                onChange={handleApplicationNoChange}
                                                required />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown"
                                        >
                                            Remark<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="text"
                                                placeholder="Enter Remark"
                                                id="remark"
                                                required value={remark}
                                                onChange={(e) => setRemark(e.target.value)} />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row className='mb-2'>
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown"
                                        >
                                            Student Id.
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="text"
                                                placeholder="Student ID"
                                                id="studentid"
                                                disabled value={studentDetails?.userInfo?.id || ""} />
                                        </Col>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown"
                                        >
                                            Cousre Name
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="text"
                                                placeholder="Course Name"
                                                id=" course"
                                                disabled value={studentDetails?.course?.courseName || ""} />
                                        </Col>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown"
                                        >
                                            Application No.
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="text"
                                                placeholder="Application No."
                                                id="appno"
                                                disabled value={studentDetails?.applicationNumber || ""} />
                                        </Col>
                                    </Row>


                                </Col>
                            </Row>
                            <Row>
                                <Col className="d-flex align-items-center justify-content-center mb-3 mt-4">
                                    <Button variant="primary" type="button"
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </Button>

                                    <PDFDownloadLink
                                        document={<PDFReport unlockedApplications={unlockedApplications} />}
                                        fileName="Unlocked_Students_Report.pdf"
                                    >
                                        {({ loading }) => (
                                            <Button variant="secondary" type="button" disabled={loading} style={{ marginLeft: "10px" }}>
                                                {loading ? 'Loading document...' : 'Unlocked Students Report'}
                                            </Button>
                                        )}
                                    </PDFDownloadLink>

                                    <ToastContainer />
                                    <Button variant="secondary" type="button" style={{ marginLeft: "10px" }}
                                        onClick={handleCancel}
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                            </Row>

                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </>
    );
}
export default UnlockRegistrationStudent;